import { render, staticRenderFns } from "./ServeOrderDetail.vue?vue&type=template&id=8edd0f46&scoped=true&"
import script from "./ServeOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ServeOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServeOrderDetail.vue?vue&type=style&index=0&id=8edd0f46&scoped=true&lang=scss&"
import style1 from "./ServeOrderDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edd0f46",
  null
  
)

export default component.exports